import apiClient from '../../../common/functions/api_axios_instance.function';
import { handleApiError } from '../../../common/functions/errorHandler.function';

/**
 * Check if the current user can start stopped invoices (Planning L4 / L5 only).
 * @returns {Promise<boolean>} - true if user can start stopped invoices
 */
export const getCanStartStopped = async () => {
  try {
    const response = await apiClient.get(
      '/approvalPersonInvoiceManagement/invoice/can-start-stopped'
    );
    const data = response?.data?.response ?? response?.data;
    return Boolean(data?.can_start_stopped);
  } catch (error) {
    handleApiError(error);
    return false;
  }
};

/**
 * Start invoice (resume from stop) - Planning L4 / L5 only
 * @param {string|number} invoiceId - The invoice id
 * @param {string} comment - Optional comment
 * @returns {Promise} - API response
 */
export const startInvoice = async (invoiceId, comment = '') => {
  try {
    const response = await apiClient.post(
      `/approvalPersonInvoiceManagement/invoice/by-id/${invoiceId}/start`,
      { comment }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

/**
 * Stop invoice - Planning L4 / L5 only
 * @param {string|number} invoiceId - The invoice id
 * @param {string} comment - Optional comment
 * @returns {Promise} - API response
 */
export const stopInvoice = async (invoiceId, comment = '') => {
  try {
    const response = await apiClient.post(
      `/approvalPersonInvoiceManagement/invoice/by-id/${invoiceId}/stop`,
      { comment }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

/**
 * Reject invoice
 * @param {string|number} invoiceId - The invoice id
 * @param {string} reasonOfRejection - Required reason
 * @param {string} comment - Optional comment
 * @returns {Promise} - API response
 */
export const rejectInvoice = async (invoiceId, reasonOfRejection, comment = '') => {
  try {
    const response = await apiClient.post(
      `/approvalPersonInvoiceManagement/invoice/by-id/${invoiceId}/reject`,
      { comment, reason_of_rejection: reasonOfRejection }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};

/**
 * Revert invoice to previous role
 * @param {string} invoiceNumber - The invoice number
 * @param {string} comment - Optional comment
 * @returns {Promise} - API response
 */
// export const revertInvoice = async (invoiceNumber, comment = '') => {
//   try {
//     const response = await apiClient.post(
//       `/approvalPersonInvoiceManagement/invoice/${invoiceNumber}/revert`,
//       { comment }
//     );
//     return response.data;
//   } catch (error) {
//     handleApiError(error);
//     throw error;
//   }
// };

/**
 * Approve invoice and forward to next role
 * @param {string|number} invoiceId - The invoice id
 * @param {string} comment - Optional comment
 * @returns {Promise} - API response
 */
export const approveInvoice = async (invoiceId, comment = '') => {
  try {
    const response = await apiClient.post(
      `/approvalPersonInvoiceManagement/invoice/by-id/${invoiceId}/approve`,
      { comment }
    );
    return response.data;
  } catch (error) {
    handleApiError(error);
    throw error;
  }
};
